import React, { memo, forwardRef } from "react";
const SvgPlusminus = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeWidth={2}
        d="M16 7v14M9 14h14M9 26h14"
      />
    </svg>
  );
});
SvgPlusminus.displayName = "SvgPlusminus";
const MemoForwardRef = memo(SvgPlusminus);
export default MemoForwardRef;
